import type {PropsWithChildren} from 'react';
import {motion} from 'framer-motion';

interface ITransitioner extends PropsWithChildren {
  classNames?: string;
  delay?: number;
  fromX?: number;
  fromY?: number;
  disabled?: boolean;
}

const Transitioner = ({children, classNames = '', delay = 0, fromX = 0, fromY = -10, disabled = false}: ITransitioner) => {
  return (
    <motion.div
      className={classNames}
      initial={disabled ? false : {opacity: 0, translateX: fromX, translateY: fromY}}
      animate={disabled ? {} : {opacity: 1, translateX: 0, translateY: 0}}
      transition={{ease: 'easeOut', delay}}>
      {children}
    </motion.div>
  );
};

export default Transitioner;
